/** @format */

import React, { Component } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
} from "../global/browserFunctions";

import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";

class AboutUs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			headermenu: true,
		};
		if (!getCookie("log")) {
			this.GoToPage("/");
		}
	}
	componentDidMount() {
		document.title = "About us"; //Change title of the page
	}
	GoToPage(path) {
		this.props.history.push(path);
	}
	render() {
		return (
			<React.Fragment>
				<Header headermenu={this.headermenu} history={this.props.history} />
				<Container className='py-6'>
					<Row>
						<Col xl='12'>
							<h6 className='text-primary text-uppercase letter-spacing-5 mb-3'>
								About us
							</h6>
							<h1 className='display-3 font-weight-bold mb-5'>Our Story</h1>
							<p className='text-lg text-muted'>
								We builds bikes for vivid lives—for taking adventures,
								reconnecting with old friends, discovering new neighbors, and
								exploring hidden gems. Inspired by the streets of Brooklyn, our
								bikes are built for style, comfort, and durability. Made with
								top quality parts, crafted with care, and sold at an affordable
								price for real people, your bike is yours for life. We
								scrutinize every component for maximum sustainability and
								performance, every millimeter of the frame for ultimate comfort
								and style. We take pride in our process, in our products, and in
								the people who sell them, and we cultivate collaboration and
								celebrate community across cities, cultures, and passions.
							</p>
						</Col>
						<Col xl='12'>
							<iframe
								style={{ width: "100%" }}
								id='youtube-4203'
								frameborder='0'
								allowfullscreen='1'
								allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
								title='Player for Built for Brooklyn | Brooklyn Bicycle Co.'
								width='640'
								height='360'
								src='https://www.youtube.com/embed/jFcWKbqGRGk?autoplay=0&amp;controls=0&amp;disablekb=1&amp;playsinline=0&amp;cc_load_policy=0&amp;cc_lang_pref=auto&amp;widget_referrer=https%3A%2F%2Fwww.brooklynbicycleco.com%2Fpages%2Fabout-us&amp;noCookie=false&amp;rel=0&amp;showinfo=0&amp;iv_load_policy=3&amp;modestbranding=1&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fwww.brooklynbicycleco.com&amp;widgetid=1'
							></iframe>
						</Col>
					</Row>
				</Container>
				<Container>
					<Row className='mb-5'>
						<Col xl='2'>
							<div className='horizontal-line d-none d-xl-block' />
						</Col>
						<Col xl='8'>
							<h4 className='text-primary text-uppercase letter-spacing-5 mb-3'>
								What Drives Us
							</h4>
						</Col>
					</Row>
					<Row className='mb-5'>
						<Col sm='4'>
							<img className='img-fluid' src='/img/photo/about1.png' alt='' />
						</Col>
						<Col
							sm='8'
							md={{ size: 6, offset: 1 }}
							className='d-flex align-items-center'
						>
							<div>
								<h2 className='text-uppercase mb-4'>
									Quality
								</h2>
								<p className='text-muted'>
									We believe everyone has a right to quality products at
									affordable prices, which is why we work so hard to make sure
									our bikes and accessories are designed with the highest
									standards, and made with the best materials in the best
									facilities. Our warranty against manufacturing defects covers
									our frames for the lifetime of the original owner and covers
									our parts for a year after purchase. That’s how certain we are
									of the quality of our products--and how much we care about the
									people with whom we do business.
								</p>
							</div>
						</Col>
					</Row>
					<Row className='mb-5'>
						<Col sm='8' md='7' lg='6' className='d-flex align-items-center'>
							<div>
								<h2 className='text-uppercase mb-4'>
									Authenticity
								</h2>
								<p className='text-muted'>
									We’re based in Brooklyn, as our name suggests, and our
									bicycles are named after streets we traverse daily, so when
									you see us developing our brand, what you’re really seeing is
									us exploring our communities--Brooklyn of course, but also the
									myriad unexpected places that every new connection takes us.
									We take pride in who we are, and that means you can take pride
									in owning our products.
								</p>
							</div>
						</Col>
						<Col
							sm='4'
							md='5'
							lg={{ offset: 1 }}
							className='d-flex align-items-center'
						>
							<img className='img-fluid' src='/img/photo/about2.jpg' alt='' />
						</Col>
					</Row>
					<Row className='mb-5'>
						<Col sm='4'>
							<img className='img-fluid' src='/img/photo/about3.jpg' alt='' />
						</Col>
						<Col
							sm='8'
							md={{ size: 6, offset: 1 }}
							className='d-flex align-items-center'
						>
							<div>
								<h2 className='text-uppercase  mb-4'>
									Respect
								</h2>
								<p className='text-muted'>
									The respect we feel for our customers is apparent in every
									aspect of our business--pricing, materials, service. We’ll
									even tell you if it seems like our bikes aren’t what you’re
									looking for-- because we genuinely want you to find the bike
									that’s right for you. This same philosophy carries over to our
									dealers, and to the folks who keep things moving in our
									office. We are easy to do business with, and believe in paying
									our employees what they’re worth, and in creating an
									environment where everyone feels comfortable contributing,
									because when one of us grows, we all grow.
								</p>
							</div>
						</Col>
					</Row>
				</Container>
				<Container className='pt-6 pb-5'>
					<Row>
						<Col xl='2'>
							<div className='horizontal-line d-none d-xl-block' />
						</Col>
						<Col xl='10'>
							<h6 className='text-primary text-uppercase letter-spacing-5 mb-3'>
								Our team
							</h6>
							<h1 className='display-3 font-weight-bold mb-3'>People</h1>
							<p className='text-muted mb-6'>
								When it comes to making our bikes the easiest to buy online, our
								team is our greatest strength. Each member of the Brooklyn
								Bicycle team is well versed in every one of our models, and
								always ready to help you find your perfect ride.
							</p>
							<Row>
								<Col xs='6' md='3' className='text-center mb-4'>
									<img
										className='avatar avatar-xxl shadow-0 mb-3'
										src='/img/photo/team 1.jpg'
										alt=''
									/>
									<h4 className='h6 mb-1'>Ryan</h4>
								</Col>
								<Col xs='6' md='3' className='text-center mb-4'>
									<img
										className='avatar avatar-xxl shadow-0 mb-3'
										src='/img/photo/team 2.jpg'
										alt=''
									/>
									<h4 className='h6 mb-1'>Danielle</h4>
								</Col>
								<Col xs='6' md='3' className='text-center mb-4'>
									<img
										className='avatar avatar-xxl shadow-0 mb-3'
										src='/img/photo/team 3.jpg'
										alt=''
									/>
									<h4 className='h6 mb-1'>Alex</h4>
								</Col>
								<Col xs='6' md='3' className='text-center mb-4'>
									<img
										className='avatar avatar-xxl shadow-0 mb-3'
										src='/img/photo/team 4.jpg'
										alt=''
									/>
									<h4 className='h6 mb-1'>Kimberly</h4>
								</Col>
								<Col xs='6' md='3' className='text-center mb-4'>
									<img
										className='avatar avatar-xxl shadow-0 mb-3'
										src='/img/photo/team 5.jpg'
										alt=''
									/>
									<h4 className='h6 mb-1'>Rob</h4>
								</Col>
							</Row>
						</Col>
					</Row>
				</Container>
				<Footer />
			</React.Fragment>
		);
	}
}

export default AboutUs;
